import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgAddrService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getAddressByLatLng(dtgGpsLat:any,dtgGpsLng:string):Observable<any>{
        let url = this.getApiBaseUrl() + "/addr";
        url += "/find/gps";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpSearchInfo = {
            "dtgGpsLat":dtgGpsLat
            ,"dtgGpsLng":dtgGpsLng
        };
        let tmpPostObject = {
            "searchInfo":tmpSearchInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}